import { createModule, from } from "../../utils";

export const grammar = createModule("grammar", {
  conjunction: from("and", "or")
});
